/**
 * Application Entry Point
 * აპლიკაციის შესავალი წერტილი
 */

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationContainer, createApiClient, AuthProvider } from '@aiia/portal-core';

import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { apiConfig, keycloakConfig } from './config';
import './index.css';

// Initialize API client
createApiClient(apiConfig);

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Render application
// AuthProvider wraps entire app with check-sso mode (doesn't force login)
// v1.48.2 — analytics page, i18n, soft-delete fixes
createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider config={keycloakConfig}>
          <App />
          <NotificationContainer />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorBoundary>
);
